var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@mui/material';
import { orderPrice as orderPriceApi } from '../../api';
import { useRequest } from '../../hooks/requestHook';
import SimulatedOrderPriceComponent from './SimulatedOrderPrice';
import OfferListSummary from '../organisms/OfferListSummary';
import FullScreenDialog from '../molecules/FullScreenDialog';
import StickyShoppingCart from './StickyShoppingCart';
import OrderShoppingCart from './OrderShoppingCart';
import SampleOrderShoppingCart from './SampleOrderShoppingCart';
import RoasterTransportToWarehouse from './RoasterTransportToWarehouse';
import OrderForm from './OrderForm';
import SampleOrderForm from './SampleOrderForm';
import PreOrderForm from './PreOrderForm';
import OrderedItemsTable from './OrderedItemsTable';
import { getSecondsFromNow, toOrderedItem } from './utils';
import CuppingCommentsDialog from './CuppingCommentsDialog';
import { formatMoneyAmount } from '../../utils/format';
import useDateRangeFormat from '../../hooks/useDateRangeFormat';
import { useLabelForEstimatedDeliveryPeriod } from '../../hooks/useLabel';
import OfferListInformationPane from '../organisms/OfferListInformationPane';
import CurrencyTextField from '../organisms/CurrencyTextField';
import { camelize } from '../../utils/camelize';
import { PaymentTimingValues } from '../../constants/orderValues';
import { useLabelForEstimatedPaymentDate } from '../../hooks/useLabel';
var Order = function (_a) {
    var _b, _c, _d, _e;
    var currentUserRole = _a.currentUserRole, itemType = _a.itemType, offerList = _a.offerList, items = _a.items, roaster = _a.roaster;
    var _f = useTranslation(), t = _f.t, i18n = _f.i18n;
    var _g = React.useState('one_time_upfront'), paymentTiming = _g[0], setPaymentTiming = _g[1];
    var _h = React.useState(false), openSimulator = _h[0], setOpenSimulator = _h[1];
    var _j = React.useState(false), openSampleOrderForm = _j[0], setOpenSampleOrderForm = _j[1];
    var _k = React.useState(), cuppingCommentOrderedItem = _k[0], setCuppingCommentOrderedItem = _k[1];
    var _l = React.useState(items.map(function (item) { return toOrderedItem(itemType, item, roaster); })), orderedItems = _l[0], setOrderedItems = _l[1];
    var simulateInvoice = useRequest(orderPriceApi.simulation);
    var _m = React.useState(getSecondsFromNow(new Date(offerList.orderStartedAt))), secondsToStartOrder = _m[0], setSecondsToStartOrder = _m[1];
    var countdownTimerRef = React.useRef();
    var formatDatePeriod = useDateRangeFormat({
        invalidText: t('labels.pending'),
    });
    var labelForEstimatedDeliveryPeriod = useLabelForEstimatedDeliveryPeriod();
    var estimatedPaymentDate = useLabelForEstimatedPaymentDate();
    var auctionOrderedItems = React.useMemo(function () {
        return orderedItems.filter(function (orderedItem) {
            return orderedItem.type === 'Offer' &&
                orderedItem.offer.orderType === 'auction';
        });
    }, [orderedItems]);
    var basicOrderedItems = React.useMemo(function () {
        return orderedItems.filter(function (orderedItem) {
            return orderedItem.type === 'TypicaStockItem' ||
                orderedItem.offer.orderType === 'basic';
        });
    }, [orderedItems]);
    var requestItems = React.useMemo(function () {
        return basicOrderedItems
            .filter(function (orderedItem) { return orderedItem.orderAmount > 0; })
            .map(function (orderedItem) { return ({
            orderedItemId: orderedItem.id,
            quantity: orderedItem.orderAmount,
            remainingQuantity: orderedItem.remainingQuantity,
            minOrder: orderedItem.minOrder,
            bagSize: orderedItem.bagSize,
            subTotalDiscount: orderedItem.subTotalDiscount,
            typicaHandlingFeeDiscount: orderedItem.typicaHandlingFeeDiscount,
            totalFeeDiscount: orderedItem.totalFeeDiscount,
        }); });
    }, [basicOrderedItems]);
    var isUSRoaster = React.useMemo(function () { return roaster.country.code === 'US'; }, [roaster]);
    var requestBids = React.useMemo(function () {
        return auctionOrderedItems
            .filter(function (orderedItem) { return orderedItem.orderAmount > 0; })
            .map(function (orderedItem) {
            var fobPrice = orderedItem.bidFobPrice;
            return __assign(__assign({}, (isUSRoaster
                ? {
                    fobPrice: undefined,
                    fobPriceUsdPerLb: fobPrice,
                }
                : {
                    fobPrice: fobPrice,
                    fobPriceUsdPerLb: undefined,
                })), { lotNumber: orderedItem.offer.lotNumber, offerId: orderedItem.offer.id, quantity: orderedItem.orderAmount });
        });
    }, [auctionOrderedItems]);
    var _o = React.useState(), simulatedOrderPrice = _o[0], setSimulatedOrderPrice = _o[1];
    React.useEffect(function () {
        if (requestItems.length === 0 && requestBids.length === 0) {
            return;
        }
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var idKey, discountEnabled, items, bids, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        idKey = itemType === 'Offer' ? 'offer_id' : 'typica_stock_item_id';
                        discountEnabled = paymentTiming !== 'after_each_delivery';
                        items = requestItems.map(function (_a) {
                            var _b;
                            var orderedItemId = _a.orderedItemId, quantity = _a.quantity, subTotalDiscount = _a.subTotalDiscount, typicaHandlingFeeDiscount = _a.typicaHandlingFeeDiscount, totalFeeDiscount = _a.totalFeeDiscount;
                            return (_b = {},
                                _b[idKey] = orderedItemId,
                                _b.quantity = quantity,
                                _b.sub_total_discount = discountEnabled ? subTotalDiscount !== null && subTotalDiscount !== void 0 ? subTotalDiscount : 0 : 0,
                                _b.typica_handling_fee_discount = discountEnabled
                                    ? typicaHandlingFeeDiscount !== null && typicaHandlingFeeDiscount !== void 0 ? typicaHandlingFeeDiscount : 0
                                    : 0,
                                _b.total_fee_discount = discountEnabled ? totalFeeDiscount !== null && totalFeeDiscount !== void 0 ? totalFeeDiscount : 0 : 0,
                                _b);
                        });
                        bids = requestBids.map(function (_a) {
                            var offerId = _a.offerId, quantity = _a.quantity, fobPrice = _a.fobPrice, fobPriceUsdPerLb = _a.fobPriceUsdPerLb;
                            return ({
                                offer_id: offerId,
                                quantity: quantity,
                                fob_price: fobPrice,
                                fob_price_usd_per_lb: fobPriceUsdPerLb,
                            });
                        });
                        return [4 /*yield*/, simulateInvoice({
                                items: items,
                                bids: bids,
                                payment_timing: paymentTiming,
                                roaster_id: roaster.id,
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response) {
                            setSimulatedOrderPrice(undefined);
                            return [2 /*return*/];
                        }
                        if (canceled)
                            return [2 /*return*/];
                        setSimulatedOrderPrice(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [
        simulateInvoice,
        requestItems,
        paymentTiming,
        roaster.id,
        requestBids,
        itemType,
    ]);
    React.useEffect(function () {
        var orderStartedAt = new Date(offerList.orderStartedAt);
        if (getSecondsFromNow(orderStartedAt) >= 3600) {
            return function () { return undefined; };
        }
        if (countdownTimerRef.current)
            clearInterval(countdownTimerRef.current);
        countdownTimerRef.current = Number(setInterval(function () {
            if (getSecondsFromNow(orderStartedAt) < 0) {
                clearInterval(countdownTimerRef.current);
                return;
            }
            setSecondsToStartOrder(getSecondsFromNow(orderStartedAt));
        }, 1000));
        return function () {
            if (countdownTimerRef.current)
                clearInterval(countdownTimerRef.current);
        };
    }, [offerList.orderStartedAt]);
    var offers = React.useMemo(function () { return orderedItems.map(function (_a) {
        var offer = _a.offer;
        return offer;
    }); }, [orderedItems]);
    var handleOrderedItemChange = React.useCallback(function (orderedItem) {
        if (!orderedItem) {
            setCuppingCommentOrderedItem(undefined);
            return;
        }
        var nextOrderedItems = orderedItems.map(function (o) {
            return o.id === orderedItem.id && o.type === orderedItem.type ? orderedItem : o;
        });
        setOrderedItems(nextOrderedItems);
        if ((cuppingCommentOrderedItem === null || cuppingCommentOrderedItem === void 0 ? void 0 : cuppingCommentOrderedItem.id) === orderedItem.id) {
            setCuppingCommentOrderedItem(orderedItem);
        }
    }, [orderedItems, cuppingCommentOrderedItem]);
    var renderDiscountFields = React.useCallback(function (offerId) {
        if (currentUserRole !== 'admin')
            return null;
        var orderedItem = orderedItems.find(function (item) { return item.offer.id == offerId; });
        if (!orderedItem)
            return null;
        var disabled = paymentTiming === 'after_each_delivery';
        var currency = roaster.country.currency;
        return (React.createElement(Box, { display: "block" },
            React.createElement(Typography, { variant: "h6" }, "Discount"),
            React.createElement(DiscountField, { label: t('params.orderPriceItem.subTotalDiscount'), disabled: disabled, onChange: function (subTotalDiscount) {
                    handleOrderedItemChange(__assign(__assign({}, orderedItem), { subTotalDiscount: subTotalDiscount }));
                }, value: orderedItem.subTotalDiscount, currency: currency }),
            React.createElement(DiscountField, { label: t('params.orderPriceItem.typicaHandlingFeeDiscount'), disabled: disabled, onChange: function (typicaHandlingFeeDiscount) {
                    handleOrderedItemChange(__assign(__assign({}, orderedItem), { typicaHandlingFeeDiscount: typicaHandlingFeeDiscount }));
                }, value: orderedItem.typicaHandlingFeeDiscount, currency: currency }),
            React.createElement(DiscountField, { label: t('params.orderPriceItem.totalFeeDiscount'), disabled: disabled, onChange: function (totalFeeDiscount) {
                    handleOrderedItemChange(__assign(__assign({}, orderedItem), { totalFeeDiscount: totalFeeDiscount }));
                }, value: orderedItem.totalFeeDiscount, currency: currency })));
    }, [currentUserRole, handleOrderedItemChange, orderedItems, t, paymentTiming]);
    var handleChangePaymentTiming = React.useCallback(function (nextPaymentTiming) {
        if (nextPaymentTiming === 'after_each_delivery') {
            setOrderedItems(function (oldItems) {
                return oldItems.map(function (item) { return (__assign(__assign({}, item), { subTotalDiscount: 0, typicaHandlingFeeDiscount: 0, totalFeeDiscount: 0 })); });
            });
        }
        setPaymentTiming(nextPaymentTiming);
    }, []);
    var simulatedInvoice = React.useMemo(function () {
        return simulatedOrderPrice && (React.createElement(SimulatedOrderPriceComponent, { itemType: itemType, offers: offers, simulatedOrderPrice: simulatedOrderPrice, isUSRoaster: isUSRoaster, renderDiscountFields: currentUserRole === 'admin' ? renderDiscountFields : undefined }));
    }, [
        itemType,
        offers,
        simulatedOrderPrice,
        isUSRoaster,
        currentUserRole,
        renderDiscountFields,
    ]);
    var sampleRequestItems = orderedItems.filter(function (orderedItem) { return orderedItem.sampleOrdered; });
    var cartItemExists = Boolean(simulatedOrderPrice) &&
        (requestItems.length > 0 ||
            (isUSRoaster
                ? requestBids.filter(function (b) { return typeof b.fobPriceUsdPerLb !== 'undefined'; })
                    .length > 0
                : requestBids.filter(function (b) { return typeof b.fobPrice !== 'undefined'; }).length >
                    0));
    var handleCloseSimulator = React.useCallback(function () {
        setOpenSimulator(false);
    }, [setOpenSimulator]);
    var handleOpenSimulator = React.useCallback(function () {
        setOpenSimulator(true);
    }, [setOpenSimulator]);
    var handleCloseSampleOrderForm = React.useCallback(function () {
        setOpenSampleOrderForm(false);
    }, [setOpenSampleOrderForm]);
    var handleOpenSampleOrderForm = React.useCallback(function () {
        setOpenSampleOrderForm(true);
    }, [setOpenSampleOrderForm]);
    var openCuppingComments = React.useCallback(function (orderedItem) {
        setCuppingCommentOrderedItem(orderedItem);
    }, []);
    var isValidOrder = React.useMemo(function () {
        if (requestItems.length === 0 && requestBids.length === 0) {
            return false;
        }
        if (isUSRoaster &&
            requestBids.find(function (bid) { return bid.fobPriceUsdPerLb === undefined; })) {
            return false;
        }
        if (!isUSRoaster && requestBids.find(function (bid) { return bid.fobPrice === undefined; })) {
            return false;
        }
        if (!simulatedOrderPrice)
            return false;
        var isIncludesNegativeFee = simulatedOrderPrice.items.find(function (item) {
            return (parseFloat(item.subTotal) < 0 ||
                parseFloat(item.typicaHandlingFee) < 0 ||
                parseFloat(item.totalFee) < 0);
        }) !== undefined;
        if (isIncludesNegativeFee)
            return false;
        return true;
    }, [requestBids, requestItems, isUSRoaster, simulatedOrderPrice]);
    var warehouseUnitPrice = React.useMemo(function () {
        if (!offerList.importedWarehouse)
            return '';
        return formatMoneyAmount(offerList.importedWarehouse.unitPrice, offerList.importedWarehouse.currency);
    }, [offerList.importedWarehouse]);
    var contributedToOkagesamaNoMori = React.useMemo(function () {
        var _a;
        return (((_a = offerList === null || offerList === void 0 ? void 0 : offerList.contributeToOkagesamaNoMoris) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
    }, [offerList]);
    var isSecondaryDirectSampleOrder = React.useMemo(function () {
        var items = orderedItems.filter(function (_a) {
            var type = _a.type, alreadySampleOrdered = _a.alreadySampleOrdered;
            return type === 'Offer' && alreadySampleOrdered;
        });
        return items.length > 0;
    }, [orderedItems]);
    var maxSampleOrderCount = React.useMemo(function () {
        return isSecondaryDirectSampleOrder ? undefined : offerList.maxSampleOrderCount;
    }, [isSecondaryDirectSampleOrder, offerList === null || offerList === void 0 ? void 0 : offerList.maxSampleOrderCount]);
    var addPaymentPeriodText = React.useMemo(function () {
        if (offerList.estimatedPaymentDate &&
            paymentTiming === 'one_time_upfront') {
            return (t('params.order.paymentTimings.oneTimeUpfront') +
                " (".concat(estimatedPaymentDate(offerList), ")"));
        }
        else {
            return t('params.order.paymentTimings.oneTimeUpfront');
        }
    }, [paymentTiming, t]);
    var paymentPeriod = React.useMemo(function () {
        var installmentPaymentParts = offerList.availablePaymentTimings
            .filter(function (paymentTiming) { return paymentTiming.includes('times_after_imported'); })
            .map(function (paymentTiming) {
            var part = paymentTiming
                .replace('times_after_imported', '')
                .replace('_', '')
                .replace(/(?:^|\s)\S/g, function (a) {
                return a.toUpperCase();
            });
            var numberMapping = {
                Two: '2',
                Three: '3',
                Four: '4',
                Five: '5',
            };
            var numberPart = numberMapping[part] || part;
            return "".concat(numberPart);
        });
        var installmentPayments = installmentPaymentParts.length > 0
            ? t('pages.offerList.installmentPaymentAfterImport') +
                "(".concat(installmentPaymentParts.join(', ')) +
                t('pages.offerList.installmentPayment') +
                ')'
            : '';
        var otherPaymentTimings = PaymentTimingValues.filter(function (paymentTiming) {
            return offerList.availablePaymentTimings.includes(paymentTiming) &&
                !paymentTiming.includes('times_after_imported');
        }).map(function (paymentTiming) {
            if (paymentTiming === 'one_time_upfront') {
                return addPaymentPeriodText;
            }
            else {
                return t("params.order.paymentTimings.".concat(camelize(paymentTiming)));
            }
        });
        return __spreadArray(__spreadArray([], otherPaymentTimings, true), (installmentPayments ? [installmentPayments] : []), true).join('\n');
    }, [offerList, t]);
    return (React.createElement(React.Fragment, null,
        offerList && offerList.status === 'expired' && (React.createElement(RoasterTransportToWarehouse, { offerList: offerList })),
        React.createElement(OfferListInformationPane, { sampleOrderPeriod: formatDatePeriod((_c = (_b = offerList.roasterOfficeDetail) === null || _b === void 0 ? void 0 : _b.sampleOrderStartedAt) !== null && _c !== void 0 ? _c : '', (_e = (_d = offerList.roasterOfficeDetail) === null || _d === void 0 ? void 0 : _d.sampleOrderExpiredAt) !== null && _e !== void 0 ? _e : ''), orderPeriod: formatDatePeriod(offerList.orderStartedAt, offerList.expiredAt), paymentPeriod: paymentPeriod, estimatedDeliveryPeriod: labelForEstimatedDeliveryPeriod(offerList.roasterTransportToWarehouse) }),
        React.createElement(Box, { mb: 4 },
            React.createElement(OfferListSummary, { content: (offerList === null || offerList === void 0 ? void 0 : offerList.offerSummaries[i18n.language]) || '', contributedToOkagesamaNoMori: contributedToOkagesamaNoMori })),
        React.createElement("div", { id: "order-form" },
            React.createElement(OrderedItemsTable, { offerList: offerList, orderedItems: orderedItems, role: currentUserRole, isSecondaryDirectSampleOrder: isSecondaryDirectSampleOrder, maxSampleOrderCount: maxSampleOrderCount, onOpenCuppingComment: openCuppingComments, onOrderedItemChange: handleOrderedItemChange, isUSRoaster: isUSRoaster }),
            (offerList === null || offerList === void 0 ? void 0 : offerList.status) === 'active' && (React.createElement(Box, { mt: 2 },
                isUSRoaster &&
                    (offerList === null || offerList === void 0 ? void 0 : offerList.offers.some(function (_a) {
                        var orderType = _a.orderType;
                        return orderType === 'auction';
                    })) && (React.createElement(Typography, { mb: 0, color: "error", variant: "caption", paragraph: true }, t('pages.roasterOrder.explanationAuctionWithFobPriceUsdPerLb'))),
                React.createElement(Typography, { color: "error", variant: "caption", paragraph: true }, t('pages.roasterOrder.explanationStockMightChange'))))),
        React.createElement(StickyShoppingCart, { visible: sampleRequestItems.length > 0 || cartItemExists }, sampleRequestItems.length > 0 ? (React.createElement(SampleOrderShoppingCart, { maxSampleOrderCount: maxSampleOrderCount, sampleOrderedItems: sampleRequestItems, onOpenSampleOrderForm: handleOpenSampleOrderForm })) : (simulatedOrderPrice && (React.createElement(OrderShoppingCart, { orderedItemType: itemType, orderedItems: orderedItems, simulatedOrderPrice: simulatedOrderPrice, buttonTitle: offerList.orderable
                ? t('params.offerList.orderable')
                : t('buttons.priceDetail'), onClickButton: handleOpenSimulator, isUSRoaster: isUSRoaster })))),
        React.createElement(FullScreenDialog, { keepMounted: true, open: openSimulator, onClose: handleCloseSimulator },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 12, md: 5 }, simulatedInvoice),
                React.createElement(Grid, { item: true, xs: 12, md: 7 }, currentUserRole === 'admin' || secondsToStartOrder < 3600 ? (React.createElement(OrderForm, { roaster: roaster, role: currentUserRole, itemType: itemType, requestItems: requestItems, requestBids: requestBids, simulatedOrderPrice: simulatedOrderPrice, orderStartedAt: new Date(offerList.orderStartedAt), secondsToStartOrder: secondsToStartOrder, warehouseUnitPrice: warehouseUnitPrice, onPaymentTimingChange: handleChangePaymentTiming, isValidOrder: isValidOrder, offerList: offerList })) : (React.createElement(PreOrderForm, { offerList: offerList, isValidOrder: isValidOrder, onPaymentTimingChange: handleChangePaymentTiming, itemType: itemType }))))),
        React.createElement(FullScreenDialog, { title: t('pages.roasterOrder.sampleOrder'), open: openSampleOrderForm, onClose: handleCloseSampleOrderForm },
            React.createElement(SampleOrderForm, { role: currentUserRole, roaster: roaster, orderedItems: sampleRequestItems })),
        React.createElement(CuppingCommentsDialog, { editable: currentUserRole === 'roaster', orderedItem: cuppingCommentOrderedItem, onChange: handleOrderedItemChange })));
};
export default Order;
var DiscountField = function (_a) {
    var currency = _a.currency, value = _a.value, label = _a.label, disabled = _a.disabled, onChange = _a.onChange;
    var _b = React.useState(false), error = _b[0], setError = _b[1];
    var handleChange = React.useCallback(function (value) {
        var num = parseFloat(value !== null && value !== void 0 ? value : '');
        if (num < 0) {
            setError(true);
            onChange(undefined);
            return;
        }
        setError(false);
        var totalFeeDiscount = isNaN(num) ? undefined : num;
        onChange(totalFeeDiscount);
    }, [onChange]);
    return (React.createElement(CurrencyTextField, { label: label, fullWidth: true, sx: {
            '&.MuiFormControl-root': {
                display: 'block',
                textAlign: 'right',
            },
        }, variant: "standard", size: "small", disabled: disabled, inputProps: {
            style: {
                textAlign: 'right',
            },
            min: 0,
        }, error: error, onChange: handleChange, value: (value !== null && value !== void 0 ? value : '0').toString(), currency: currency }));
};
